import { cloneDeep, findIndex, reduce } from 'lodash';
import { PropertyType } from '../../../common';
import { TreeValueType } from 'esa-ui-library/lib/types';

export const getActiveLabels = (options: PropertyType[]): string[] => {
	const active = options?.reduce((acc: string[], item: PropertyType) => {
		if (item.isChecked) {
			acc.push(item.label);
		}
		return acc;
	}, []);
	return active || [];
};

export const getUpdateOptions = (option: PropertyType, options: PropertyType[]): PropertyType[] => {
	const state = cloneDeep(options);
	const optionIndex = findIndex(state, ['value', option.value]);
	if (optionIndex !== -1) {
		const currentStatus = Boolean(state[optionIndex]?.isChecked);
		state[optionIndex].isChecked = !currentStatus;
	}
	return state;
};

export const getFilterValue = (options: PropertyType[], field = 'value'): string => {
	const result = reduce(
		options,
		(acc, item) => {
			if (item.isChecked) {
				acc += `${item[field]},`;
			}

			return acc;
		},
		''
	);
	return result.slice(0, -1);
};

export const selectPreselectedOptions = (
	options: PropertyType[],
	selected: string,
	field = 'value'
): PropertyType[] => {
	const filters = selected.split(',');

	const result = options.map((option) => {
		const newOption = { ...option };
		const value = option[field]?.toString() || '';
		if (filters.includes(value)) {
			newOption.isChecked = true;
		}
		return newOption;
	});

	return result;
};

export const selectPreselectedPartnersOptions = (options: TreeValueType[], selected: string): TreeValueType[] => {
	const filters = selected.split(',');
	const result: TreeValueType[] = [];

	const processOption = (option: TreeValueType): TreeValueType => {
		const newOption: TreeValueType = { ...option };
		if (filters.includes(option.value.toString())) {
			result.push(newOption);
		}
		if (option.options && Array.isArray(option.options)) {
			newOption.options = option.options.map(processOption);
		}
		return newOption;
	};

	options.forEach(processOption);

	return result;
};
